import { useEffect, useState } from 'react';
import { Switch } from '@mui/material';
import { CommunityToggleModal, Influencer } from './CommunityToggleModal';
import { useGetInfluencerQuery } from '../../../../generated/graphql';
import {
  hasPremiumFeaturesOTPIds,
  isSubscriptionCreator,
} from '@client/new/common/offering.helpers';

export const CommunityStateToggle = ({
  influencer,
  isEnabled,
}: {
  influencer: Influencer;
  isEnabled: boolean;
}) => {
  const [isCommunityModalVisible, setCommunityModalVisible] =
    useState<boolean>(false);
  const [isCommunityEnabled, setCommunityEnabled] = useState(false);
  const influencerQuery = useGetInfluencerQuery({
    variables: { id: influencer.id },
    skip: !influencer.id,
  });

  useEffect(() => {
    influencerQuery.refetch();
  }, [isCommunityEnabled]);

  useEffect(() => {
    setCommunityEnabled(isEnabled);
  }, [isEnabled]);

  const onChange = () => {
    setCommunityModalVisible(true);
  };

  const disabled =
    !isSubscriptionCreator(influencer.offering) &&
    !hasPremiumFeaturesOTPIds(influencer?.customizations);
  return (
    <>
      <Switch
        checked={isCommunityEnabled}
        onChange={onChange}
        disabled={disabled}
      />
      <CommunityToggleModal
        isModalVisible={isCommunityModalVisible}
        onDismiss={() => setCommunityModalVisible(false)}
        influencer={influencer}
        setCommunityEnabled={setCommunityEnabled}
        isCommunityEnabled={isCommunityEnabled}
        setCommunityModalVisible={setCommunityModalVisible}
      />
    </>
  );
};
